import React, { useState, useEffect } from 'react'
import { FormControlLabel, Switch, Typography } from '@mui/material'
import LabelWithTooltipComponent from './LabelWithTooltipComponent'

interface ISwitchComponentProps {
  checked: boolean
  name?: string
  id?: string
  disabled?: boolean
  color?: 'primary' | 'secondary'
  onChange?: (checked: boolean) => void
  label: string
  description?: string
}

const SwitchComponent: React.FC<ISwitchComponentProps> = (props) => {
  const color: 'primary' | 'secondary' = props.color || 'primary'
  const [checked, setChecked] = useState(props.checked)

  useEffect(() => {
    setChecked(props.checked)
  }, [props.checked])

  const handleChange = (checked: boolean) => {
    setChecked(checked)
    props.onChange && props.onChange(checked)
  }

  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          id={props.id}
          disabled={props.disabled}
          onChange={((event: React.ChangeEvent<HTMLInputElement>) => handleChange(event.target.checked))}
          color={color}
          name={props.name}
        />
      }
      label={
        <Typography variant='body2' style={{ display: 'flex' }}>
          <LabelWithTooltipComponent
            label={props.label}
            description={props.description}
          />
        </Typography>
      }
    />
  )
}

export default SwitchComponent
